import Vue from 'vue'

const isDev = process.env.NODE_ENV !== 'production'
const servicesBaseUrl = isDev ? 'https://gb.dev.gb.ru' : 'https://gb.ru'

// for dev

const state = () => ({
  newBlocks: {},
  newTrajectories: null,
  notifications: {},
  attendees: {},
  courses: {},
  lessons: {},
  quarters: {},
  mentor: {},
  streams: {},
  chapters: {},
  tests: {},
  streamLists: {},
  questionnaires: {},
  homeworks: {},
  specializationsList: {},
  isSettingsChanged: false,
  isLoadingQuestionnaires: false,
  isOnboardingShown: false,
  isStudentDataLoading: true,
  blocks: []
})

const mutations = {
  set (state, { type, payload }) {
    state[type] = payload
  },

  resetSpecializationsList(state) {
    state.specializationsList = {}
  },

  setBlockData(state, [blockId, block]) {

    // BACKEND сделать на беке что бы blockType приходил с бека такой же как в запросе blocks.
      state.newBlocks[blockId] = { ...state.newBlocks[blockId], ...block }

  },

  deleteNotificationCourse(state, path) {
    Vue.delete(state.notifications[path.productAttendeeId].courses, path.id)
  },

  deleteNotificationBlock(state, blockId) {
    state.notifications[blockId].blockNotificationsIds.shift()
  },

  deleteNPSCard(state) {
    const questionnaires = { ...state.questionnaires }
    delete questionnaires.nps
    state.questionnaires = questionnaires
  }
}

const actions = {
  getPath() {
      const stagingNum = sessionStorage.getItem('education-dev-staging') || '02'
      const staging =   `staging${stagingNum}`

    return this.$config.isProd ? 'https://gb.ru' : `https://${staging}.staging.gb.ru`
  },

  async getBlocks({ commit, dispatch }) {

    commit('set', {
      type: 'isStudentDataLoading',
      payload: true
    })
    try {
      const path = await dispatch('getPath')

      const { data } = await this.$axios.get(
        `${path}/api/v2/education/student/blocks`,
        { useCache: false }
      )
      const newBlocks = data || {}
      // BACKEND УБРАТЬ МЕНТОРА С БЕКА
      delete newBlocks.mentor

      let newTrajectories = {}
      const notifications = {}

      await commit('set', {
        type: 'newBlocks',
        payload: newBlocks
      })

      for (const key in newBlocks) {
        const block = newBlocks[key]

            if (block.blockType === 'main') {
              newTrajectories[block.trajectoryId || 'others'] = block.trajectoryTitle || 'Другие программы обучения'
            }

        const blockNotifications = { courses: {}, blockNotificationsIds: [] }
        block.educationNotices?.forEach(notice => {
          if (notice.triggerKind === 'ProductAttendee') {
            blockNotifications.blockNotificationsIds.push(notice.id)
          } else {
            blockNotifications.courses[notice.triggerId] = notice
          }

          blockNotifications.type = block.blockType
          notifications[block.productAttendeeId || block.trajectoryProductId || block.type] = blockNotifications
        })

      }

      if (Object.keys(newTrajectories).length < 1) {
        newTrajectories = null
      }

      await commit('set', {
        type: 'newTrajectories',
        payload: newTrajectories
      })

      commit('set', {
        type: 'notifications',
        payload: notifications
      })

      // временно вернул для того чтобы не падало /education/trajectories
      commit('set', {
        type: 'blocks',
        payload: Object.values(newBlocks)
      })
    } catch (e) {
      console.error(e)
    } finally {
      commit('set', {
        type: 'isStudentDataLoading',
        payload: false
      })
    }
  },

  async fetchBlockData({ commit, state, dispatch }, id) {
    const path = await dispatch('getPath')

    try {
      const apiPath = id ? `${path}/api/v2/education/student/product_attendees/${id}` : `${path}/api/v2/education/student/separated_block`

      const { data: blockData } = await this.$axios.get(apiPath, { useCache: false })


      const {
        attendees,
        courses,
        lessons,
        quarters,
        blocks,
        streams,
        chapters,
        certificationTests,
        streamLists
      } = blockData

      if (!blocks) return
       // BACKEND сделать на беке что бы при фетче конкретного блока не было этой обертки blocks
      const [blockId, newBlock] = Object.entries(blocks)[0] || []
      if (!newBlock) return

      commit('set', {
        type: 'tests',
        payload: { ...state.tests, ...certificationTests }
      })

      commit('set', {
        type: 'streamLists',
        payload: { ...state.streamLists, ...streamLists }
      })

      commit('set', {
        type: 'streams',
        payload: { ...state.streams, ...streams }
      })

      commit('set', {
        type: 'chapters',
        payload: { ...state.chapters, ...chapters }
      })

      commit('set', {
        type: 'quarters',
        payload: { ...state.quarters, ...quarters }
      })

      commit('set', {
        type: 'courses',
        payload: { ...state.courses, ...courses }
      })

      commit('set', {
        type: 'lessons',
        payload: { ...state.lessons, ...lessons }
      })

      await commit('set', {
        type: 'attendees',
        payload: { ...state.attendees, ...attendees }
      })

      // BACKEND сделать на беке что бы при фетче отдельного блока id тоже был separate
      commit('setBlockData', [blockId || 'separate', newBlock])
    } catch (e) {
      console.error(e)
    }
  },

  async fetchBlockProgressItems({ commit, state, dispatch }, id) {
    const path = await dispatch('getPath')
    try {
      const apiPath = id ? `${path}/api/v2/education/student/product_attendees/${id}/lessons_progress` : `${path}/api/v2/education/student/separated_block/lessons_progress`

      const { data:blockData } = await this.$axios.get(apiPath, { useCache: false })

      const {
        lessons,
        chapters,
        certificationTests
      } = blockData

      commit('set', {
        type: 'chapters',
        payload: { ...state.chapters, ...chapters }
      })

      commit('set', {
        type: 'tests',
        payload: { ...state.tests, ...certificationTests }
      })

      commit('set', {
        type: 'lessons',
        payload: { ...state.lessons, ...lessons }
      })
    } catch (e) {
      console.error(e)
    }
  },

  async fetchSpecializationsList({ commit, dispatch }, trajectoryId) {
   try{
     const path = await dispatch('getPath')
     const { data } = await this.$axios.get(`${path}/api/v2/trajectory_products/specializations?trajectory_id=${trajectoryId}`)
     commit('set', {
       type:'specializationsList',
       payload: data
     })
   } catch (e) {
     console.error(e)
   }

  },

  async bindSlotToProgram({ dispatch }, [slotId, productId]) {
    const path = await dispatch('getPath')

    try {
      return  await this.$axios.put(`${path}/api/v2/trajectory_products/${slotId}`, { product_id: +productId })
    } catch (e) {
      this.$notifications.addDanger('Что-то пошло не так ...')
      console.error(e)
    }
  },

  async fetchQuestionnairesData({ commit }) {
    try {
      commit('set', {
        type: 'isLoadingQuestionnaires',
        payload: true
      })

      const { questionnaires } = await this.$axios.get(`${servicesBaseUrl}/api/marketing/v1/questionnaires/completed`)

      if (questionnaires?.nps) {
        questionnaires.nps.isNPS = true
      }

      commit('set', {
        type: 'questionnaires',
        payload: questionnaires || {}
      })

      commit('set', {
        type: 'isLoadingQuestionnaires',
        payload: false
      })
    } catch (e) {
      console.error(e)
    }
  },

  async studentAttendStream({ state, commit, dispatch }, ids) {
    const path = await dispatch('getPath')
    try {
      const { data } = await this.$axios.post(
        `${path}/api/v2/education/student/attendees`,
        {
          ...ids
        }
      )

      commit('set', {
        type: 'lessons',
        payload: { ...state.lessons, ...data.lessons?.reduce((a, v) => ({ ...a, [v.id]: v }), {}) }
      })

      commit('set', {
        type: 'attendees',
        payload: { ...state.attendees, [data.attendee.id]: data.attendee }
      })
    } catch (e) {
      console.error(e)
    }
  },

  async studentAttendStudyGroupCourse({ commit, state, dispatch }, id) {
    const path = await dispatch('getPath')
    try {
      const { data } = await this.$axios.post(
        `${path}/api/v2/education/student/attendees/attend_study_group`,
        {
          id
        }
      )

      commit('set', {
        type: 'lessons',
        payload: { ...state.lessons, ...data.lessons?.reduce((a, v) => ({ ...a, [v.id]: v }), {}) }
      })

      commit('set', {
        type: 'attendees',
        payload: { ...state.attendees, [data.attendee.id]: data.attendee }
      })
    } catch (e) {
      console.error(e)
    }
  },

  async studentCancelAttendStream({ state, commit, dispatch }, id) {

    const path = await dispatch('getPath')
    try {
      const { data } = await this.$axios.delete(
        `${path}/api/v2/education/student/attendees`,
        { data: id }
      )
      const { attendee, streams } = data
      commit('set', {
        type: 'streams',
        payload: { ...state.streams, ...streams }
      })

      commit('set', {
        type: 'attendees',
        payload: { ...state.attendees, [attendee?.id]: attendee }
      })
    } catch (e) {
      console.error(e)
    }
  },
  // Mentor Apis
  async mentorAttendStream({ dispatch }, streamId) {

    const path = await dispatch('getPath')
    try {
      await this.$axios.post(
        `${path}/api/v2/mentors/${streamId}`
      )
    } catch (e) {
      console.error(e)
    }
  },

  async mentorCancelAttendStream({ dispatch }, attendeeId) {

    const path = await dispatch('getPath')
    try {
      await this.$axios.delete(
        `${path}/api/v2/mentors/${attendeeId}`,
      )
    } catch (e) {
      console.error(e)
    }
  },

  async getMentorBlockData({ commit, state, dispatch }) {
    try {
      const path = await dispatch('getPath')

      const { data } = await this.$axios.get(
        `${path}/api/v2/education/mentor`,
        { useCache: false }
      )

      const {
        blocks,
        courses,
        lessons,
        streams,
        studyGroups,
        suggestedStreams
      } = data

      commit('set', {
        type: 'mentor',
        payload: { ...state.mentor, courses, lessons, streams, studyGroups, suggestedStreams, block: blocks[0] || null }
      })
    } catch (e) {
      console.error(e)
    }
  },

  async studentAttendElective({ dispatch }, [courseId, productAttendeeId]) {

    const path = await dispatch('getPath')
    try {
      const apiPath = `${path}/api/v2/education/student/supplements`
      await this.$axios.post(
        apiPath,
        { course_id: courseId, product_attendee_id: productAttendeeId },
      )
    } catch (e) {
      console.error(e)
    }
  },

  async selectStream({ dispatch }, data) {
    const path = await dispatch('getPath')

    try {
      const apiPath = `${path}/api/v2/education/student/stream_lists`

      await this.$axios.post(
        apiPath,
        data
      )

      this.$notifications.addSuccess(`Вы записались в группу ${data.id}`)
    } catch (e) {
      this.$notifications.addDanger('Что-то пошло не так ...')
      console.error(e)
    }
  },

  async changeStream({ dispatch }, data) {
    const path = await dispatch('getPath')

    try {
      const apiPath = `${path}/api/v2/education/student/stream_lists/change`

      await this.$axios.post(
        apiPath,
        data
      )

      this.$notifications.addSuccess(`Вы записались в группу ${data.id}`)
    } catch (e) {
      this.$notifications.addDanger('Что-то пошло не так ...')
      console.error(e)
    }
  },

  async archiveAttendee({ dispatch }, id) {
    const path = await dispatch('getPath')
    try {
      const apiPath = `${path}/api/v2/education/student/attendees/archive`
      await this.$axios.post(
        apiPath,
        { id },
      )
      this.$notifications.addSuccess('Курс успешно добавлен в Архивные')
    } catch (e) {
      this.$notifications.addDanger('Что-то пошло не так ...')
      console.error(e)
    }
  },

  async unArchiveAttendee({ dispatch }, id) {
    const path = await dispatch('getPath')
    try {
      const apiPath = `${path}/api/v2/education/student/attendees/unarchive`
      await this.$axios.delete(
        apiPath,
        {
          data: {
            id
          }
        }
      )
      this.$notifications.addSuccess('Курс успешно возвращен в Активные')
    } catch (e) {
      this.$notifications.addDanger('Что-то пошло не так ...')
      console.error(e)
    }
  },

  async getIsMentorPageVisited() {
    try {
      return await this.$axios.get('https://gb.ru/api/lms/v1/education/mentoring/visited')
    } catch (e) {
      console.error(e)
    }
  },

  async setIsMentorPageVisited() {
    try {
      await this.$axios.post('https://gb.ru/api/lms/v1/education/mentoring/visited')
    } catch (e) {
      console.error(e)
    }
  },

  async removeNotice({ dispatch }, noticeId) {
    const path = await dispatch('getPath')
    try {
      const apiPath = `${path}/api/v2/education/student/education_notices/${noticeId}`
      const response = await this.$axios.post(
        apiPath,
        null,
      )

      if (response.status >= 200 && response.status < 300) {
        return 'ok'
      } else {
        return 'error'
      }
    } catch (e) {
      console.error(e)

      return 'error'
    }
  },

  async getHomeworksCounters({ commit, state }) {
    try {
      if (!state.homeworks.counters) {
        const counters = await this.$axios.get(`${servicesBaseUrl}/api/lms/v1/homeworks/counters`)

        commit('set', {
          type: 'homeworks',
          payload: { ...state.homeworks, ...counters }
        })
      }
    } catch (e) {
      console.error(e)
    }
  },

  async getHomeworksByType({ commit, state }, type) {
    try {
      if (!state.homeworks[type]) {
        const homeworksData = await this.$axios.get(`${servicesBaseUrl}/api/lms/v1/homeworks/${type}`)
        let homeworks

        if (type === 'completed') {
          homeworks = homeworksData || {}
        }

        if (type === 'current') {
          homeworks = homeworksData?.currentHomeworks || {}
        }

        if (type === 'verified') {
          homeworks = homeworksData?.verifiedHomeworks || {}

          commit('set', {
            type: 'homeworks',
            payload: { ...state.homeworks, filters: homeworksData?.courses }
          })
        }

        commit('set', {
          type: 'homeworks',
          payload: { ...state.homeworks, [type]: homeworks }
        })
      }
    } catch (e) {
      console.error(e)
    }
  },

  async getSettingsBlocksList({ dispatch }) {
    const path = await dispatch('getPath')
    try {
      const apiPath = `${path}/api/v2/education/student/products_list`
      const { data } = await this.$axios.get(
        apiPath
      )

      return data
    } catch (e) {
      console.error(e)

      return 'error'
    }
  },

  async setFacultyHiddenStatus({ commit, dispatch }, isHidden) {
    const path = await dispatch('getPath')
    try {
      const apiPath = `${path}/api/v2/education/student/product_attendees/toggle_supplements`
      const { data } = await this.$axios.post(
        apiPath,
        { hidden: isHidden },
      )

      await commit('set', {
        type: 'isSettingsChanged',
        payload: true
      })

      return data
    } catch (e) {
      this.$notifications.addDanger('Что-то пошло не так ...')
      console.error(e)

      return 'error'
    }
  },

  async setBlockVisibleStatus({ commit, dispatch }, [isShow, blockId]) {
    const path = await dispatch('getPath')
    try {
      const apiPath = `${path}/api/v2/education/student/product_attendees/${blockId}/toggle_visible`
      const { data } = await this.$axios.post(
        apiPath,
        { visible: isShow },
      )

      await commit('set', {
        type: 'isSettingsChanged',
        payload: true
      })

      return data
    } catch (e) {
      this.$notifications.addDanger('Что-то пошло не так ...')
      console.error(e)

      return 'error'
    }
  }
}

const getters = {
  getActiveQuestionnairesCount(state) {
    return Object.values(state.questionnaires).filter(q => {
      return !q.dateCompleted
    }).length || 0
  },

  getHomeworksCounter(state) {
    if (state.homeworks.counters) {
      return Object.values(state.homeworks.counters).reduce((a, c) => a + c, 0)
    }

    return 0
  }
}

export { state, mutations, actions, getters }
